import React, { useState } from "react"
import { Link } from "gatsby"
 
const Header = ({ location, title }) => {
  const rootPath = `${__PATH_PREFIX__}/`
  const isRootPath = location.pathname === rootPath
  let header
  const [isActive, setActive] = useState(false)

  if (isRootPath) {
    header = (
      <h1 className="font-bold">
        <Link className="header-logo text-3xl" to="/">Designup</Link>
      </h1>
    )
  } else {
    header = (
      <Link className="header-logo text-3xl" to="/">Designup</Link>
    )
  }

  return (
    <header className="shadow-xl shadow-black/[0.02]">
      <div className="container mx-auto py-[15px]">
        <div className="flex justify-between items-center">
          <div className="headerbar">
            {header}
            <a className="du-btn-svg du-drawer__bar" onClick={() => setActive(!isActive)} href="#header" data-toggle="drawer" data-target="du-drawer-header">
              <span></span><span></span><span></span>
            </a>
          </div>
          <nav className={`du-drawer flex justify-between items-center ${isActive ? 'is-active' :''}`}>
            <a className="du-btn-svg du-drawer__close" onClick={() => setActive(!isActive)} href="#header" data-toggle="drawer" data-target="du-drawer-header">
              <span></span><span></span>
            </a>
            <ul className="flex flex-col lg:flex-row lg:space-x-5 text-lg lg:text-sm font-bold">
              <li className="p-4 lg:p-0"><Link className="click__header-nav" to="/">トップページ</Link></li>
              <li className="p-4 lg:p-0"><Link className="click__header-nav" to="/product-web-uikit.html">WEB-UIKIT <span className="ml-1 py-1 px-2 rounded leading-none text-xs font-bold bg-cyan-500 text-white">New</span></Link></li>
              <li className="p-4 lg:p-0"><Link className="click__header-nav" to="/product-lp-uikit.html">LP-UIKIT</Link></li>
              <li className="p-4 lg:p-0"><Link className="click__header-nav flex items-center" to="/contact.html">
                <svg className="hidden lg:block" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path d="M0 3v18h24v-18h-24zm21.518 2l-9.518 7.713-9.518-7.713h19.036zm-19.518 14v-11.817l10 8.104 10-8.104v11.817h-20z"/></svg>
                <span className="lg:ml-2">お問い合わせ</span>
              </Link></li>
            </ul>
          </nav>
        </div>
      </div>
    </header>
  )
}
 
 export default Header
 